/**
 * Preferências de aviso (parte D1, 01/10/2026) — `/notifications/preferences/avisos`.
 * O `api` já tem o `/api/v1` no baseURL: o caminho nunca leva o prefixo.
 */
import api from "@/services/api";

export type NivelDeAviso = "som" | "aviso" | "sino" | "nada";

export interface CategoriaDeAviso {
  chave: string;
  rotulo: string;
  nivel: NivelDeAviso;
  padrao: NivelDeAviso;
  niveis_permitidos: NivelDeAviso[];
  piso: NivelDeAviso | null;
  motivo_do_piso: string | null;
}

export interface PreferenciasDeAviso {
  categorias: CategoriaDeAviso[];
  recebe_alertas_do_sistema: boolean;
}

const BASE = "/notifications/preferences/avisos";

export const preferenciasDeAvisoService = {
  listar: async (): Promise<PreferenciasDeAviso> => (await api.get<PreferenciasDeAviso>(BASE)).data,
  definir: async (chave: string, nivel: NivelDeAviso): Promise<CategoriaDeAviso> =>
    (await api.put<CategoriaDeAviso>(`${BASE}/${encodeURIComponent(chave)}`, { nivel })).data,
  restaurarPadroes: async (): Promise<void> => {
    await api.delete(BASE);
  },
};

/**
 * D3 (passo 19): a API de onde as preferências vêm e vão, injetável. O interno usa `ADAPTADOR_INTERNO` (em
 * `hooks/usePreferenciasDeAviso.ts`), o portal o `ADAPTADOR_DO_PORTAL` (`portalPreferenciasDeAvisoService.ts`). A chave de cache é
 * própria de cada um: o `queryClient` é um singleton e nenhum dos dois logouts limpa o cache — com a mesma chave o parceiro
 * veria, por 30 s, os dados da pessoa de antes.
 */
export interface AdaptadorDePreferencias {
  chaveDoCache: readonly string[];
  listar: () => Promise<PreferenciasDeAviso>;
  definir: (chave: string, nivel: NivelDeAviso) => Promise<CategoriaDeAviso>;
  restaurarPadroes: () => Promise<void>;
}
